import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TimePeriod, WorkDay } from '@apaq/orgkit-js';
import { addMilliseconds, addMinutes, fromUnixTime, set, setHours, setMinutes, startOfDay } from 'date-fns';

const EPOCH = fromUnixTime(0);

@Component({
  selector: 'ws-time-period-selector',
  templateUrl: './time-period-selector.component.html',
  styleUrls: ['./time-period-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TimePeriodSelectorComponent,
      multi: true
    }]

})
export class TimePeriodSelectorComponent implements OnInit, ControlValueAccessor {

  @Input() label?: string;
  pits: Date[] = [];
  period: WorkDay = { startTime: startOfDay(EPOCH), endTime: set(startOfDay(EPOCH), { hours: 23, minutes: 59 }) };
  periodInMillis = { start: startOfDay(EPOCH).getTime(), end: set(startOfDay(EPOCH), { hours: 23, minutes: 59 }).getTime() };
  onChange?: (workDay: WorkDay) => void;
  disabled = false;

  constructor() { }

  writeValue(period: WorkDay): void {
    this.period = period;
    this.periodInMillis = { start: this.round(period?.startTime?.getTime() ?? 0, 1800000), end: this.round(period?.endTime?.getTime() ?? 1439, 1800000) }
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void { }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
    const midnight = startOfDay(EPOCH);

    for (let i = 0; i < 1440; i += 30) {
      this.pits.push(addMinutes(midnight, i));
    }
    this.pits.push(addMinutes(midnight, 1439));
  }

  onStartChange(event: Event) {
    const value = (event as CustomEvent).detail.item.value;
    this.periodInMillis.start = parseInt(value);
    this.periodInMillis.end = Math.max(this.periodInMillis.start, this.periodInMillis.end);
    this.handleChange();
  }

  onEndChange(event: Event) {
    const value = (event as CustomEvent).detail.item.value;
    this.periodInMillis.end = parseInt(value);
    this.periodInMillis.start = Math.min(this.periodInMillis.start, this.periodInMillis.end);
    this.handleChange();
  }

  handleChange() {
    if(this.onChange) {
      this.period.startTime = addMilliseconds(EPOCH, this.periodInMillis.start);
      this.period.endTime = addMilliseconds(EPOCH, this.periodInMillis.end);
      this.onChange!(this.period);
    }
  }

  private round(input: number, step: number) {
    return ((Math.round(input / step)) * step);
  }

}
